import React from 'react';
import { motion } from 'framer-motion';
import { approachData } from '../data/mock';

const ApproachSection = () => {
  return (
    <section className="py-32 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <span className="text-[#00ff88] text-sm font-medium uppercase tracking-wider mb-4 block">
            Methodology
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            My <span className="gradient-text">Approach</span>
          </h2>
          <p className="text-white/50 text-lg max-w-2xl mx-auto">
            A systematic methodology to ensure comprehensive security coverage.
          </p>
        </motion.div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {approachData.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="bento-card p-8 relative overflow-hidden group"
            >
              {/* Phase Number Background */}
              <div className="absolute top-4 right-4 font-display text-[100px] font-bold text-white/[0.03] leading-none group-hover:text-[#00ff88]/[0.08] transition-colors duration-500">
                {step.phase}
              </div>

              <div className="relative z-10">
                {/* Phase Badge */}
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#00ff88]/10 rounded-full mb-6">
                  <span className="text-[#00ff88] text-sm font-medium">
                    Phase {step.phase}
                  </span>
                </div>

                {/* Title */}
                <h3 className="font-display text-xl font-semibold text-white mb-4 group-hover:text-[#00ff88] transition-colors">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-white/50 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>

              {/* Connector Line */}
              {index < approachData.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-3 w-6 h-0.5 bg-gradient-to-r from-[#00ff88]/50 to-transparent" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;
